import { render } from "./DomainRefreshMethod.vue?vue&type=template&id=b1f1ad30&scoped=true"
import script from "./DomainRefreshMethod.vue?vue&type=script&lang=js"
export * from "./DomainRefreshMethod.vue?vue&type=script&lang=js"

import "./DomainRefreshMethod.vue?vue&type=style&index=0&id=b1f1ad30&scoped=true&lang=css"
import "./DomainRefreshMethod.vue?vue&type=style&index=1&id=b1f1ad30&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f1ad30"]])

export default __exports__